import React, { useState } from 'react';

export const attributeOptions = {
  columns: [
      {
          id: 1, name: 'list', label: 'Primary Values', sortable: false, type: 'string',
          component: (row) => {
              return (
                  <div>
                      <>
                          {row.list.map((record, i) => {
                              return (
                                  <div key={i}>
                                      <div className="lh-base">{record.name}</div>
                                  </div>
                              )
                          })
                          }
                      </>
                  </div>
              )
          }
      }
  ],
  actions: [],
  actionsThead: false,
  sortable: false,
  dateType: false,
  showSearch: false,
  searchable: false,
  paging: false,
};